import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';
import './FileUploader.scss';

import { Uppy } from '@uppy/core';
import { Dashboard as UppyDashboard } from '@uppy/react';
import { instanceOf } from 'prop-types';
import React from 'react';

const defaults = {
  // Do not render a "retry" button. We trigger uploads with controls outside
  // of the Uppy Dashboard and depend on the `manager.upload()` promise to wait
  // for completion. Retries triggered through the Uppy Dashboard UI would not
  // trigger the necessary completion callbacks.
  hideRetryButton: true,

  // Disable pause/resume functionality for now (not currently supported).
  hidePauseResumeButton: true,

  // Hide Uppy branding.
  proudlyDisplayPoweredByUppy: false,
};

class FileUploader extends React.Component {
  componentWillUnmount() {
    const { manager } = this.props;
    manager.reset();
  }

  render() {
    const { manager, ...props } = this.props;
    return <UppyDashboard uppy={manager} {...defaults} {...props} />;
  }
}

FileUploader.propTypes = {
  manager: instanceOf(Uppy).isRequired,
};

export default FileUploader;
